const ENTITY_STATUS_CATALOG_PROCESSING_TYPE = "backstage.io/catalog-processing";

export { ENTITY_STATUS_CATALOG_PROCESSING_TYPE };
//# sourceMappingURL=status.esm.js.map
